/*
 * This file is generated by icons/template.js
 */

import type { SVGProps } from 'react';
import type { StyledComponent } from 'styled-components';
import type { CommonProps } from '../constants';
import type { IconSizeProps } from '../lib/iconSize';

export type IconComponent = StyledComponent<(props: SVGProps<SVGSVGElement>) => JSX.Element, any, CommonProps & IconSizeProps>;

export { IconBcorp } from './Bcorp';
export { IconBracketDown } from './BracketDown';
export { IconBracketLeft } from './BracketLeft';
export { IconBracketRight } from './BracketRight';
export { IconBracketUp } from './BracketUp';
export { IconBrowse } from './Browse';
export { IconBullhorn } from './Bullhorn';
export { IconCAlt } from './CAlt';
export { IconC } from './C';
export { IconCheck } from './Check';
export { IconCircleCheck } from './CircleCheck';
export { IconClock } from './Clock';
export { IconClose } from './Close';
export { IconCoins } from './Coins';
export { IconComment } from './Comment';
export { IconDefaultAvatar } from './DefaultAvatar';
export { IconDmResponse } from './DmResponse';
export { IconDownload } from './Download';
export { IconDuplicate } from './Duplicate';
export { IconEdit } from './Edit';
export { IconEllipsisV } from './EllipsisV';
export { IconEmbed } from './Embed';
export { IconEye } from './Eye';
export { IconFacebookAlt } from './FacebookAlt';
export { IconFacebook } from './Facebook';
export { IconFbMessenger } from './FbMessenger';
export { IconGoogle } from './Google';
export { IconHeartOutline } from './HeartOutline';
export { IconHeart } from './Heart';
export { IconImageUpload } from './ImageUpload';
export { IconInfo } from './Info';
export { IconLeftCurvedArrow } from './LeftCurvedArrow';
export { IconLineAlt } from './LineAlt';
export { IconLine } from './Line';
export { IconLink } from './Link';
export { IconLinkedInAlt } from './LinkedInAlt';
export { IconLinkedIn } from './LinkedIn';
export { IconLocation } from './Location';
export { IconLockFilled } from './LockFilled';
export { IconLock } from './Lock';
export { IconMail } from './Mail';
export { IconMenu } from './Menu';
export { IconMinus } from './Minus';
export { IconNews } from './News';
export { IconNotVerified } from './NotVerified';
export { IconNotifications } from './Notifications';
export { IconPencil } from './Pencil';
export { IconPetitionUpdate } from './PetitionUpdate';
export { IconPlay } from './Play';
export { IconPlus } from './Plus';
export { IconPrint } from './Print';
export { IconPromote } from './Promote';
export { IconRightCurvedArrow } from './RightCurvedArrow';
export { IconSearch } from './Search';
export { IconShare } from './Share';
export { IconSign } from './Sign';
export { IconSponsored } from './Sponsored';
export { IconStartPetition } from './StartPetition';
export { IconSupporters } from './Supporters';
export { IconTag } from './Tag';
export { IconTrash } from './Trash';
export { IconTrending } from './Trending';
export { IconTwitterAlt } from './TwitterAlt';
export { IconTwitter } from './Twitter';
export { IconVerified } from './Verified';
export { IconVictory } from './Victory';
export { IconVkAlt } from './VkAlt';
export { IconVk } from './Vk';
export { IconWhatsappAlt } from './WhatsappAlt';
export { IconWhatsapp } from './Whatsapp';
